// MCP Security — Country flag.
//
// Pure-emoji ISO-2 → regional-indicator pair (U+1F1E6 … U+1F1FF).
// Browsers that lack country-flag glyphs (Windows Chrome, roughly)
// render the two letters as monospaced capitals which still read as
// a country code — good enough fallback.

import React from "react";
import tokens from "./tokens";

function codeToEmoji(cc) {
  if (!cc || typeof cc !== "string" || cc.length !== 2) return "";
  const base = 0x1f1e6;
  const upper = cc.toUpperCase();
  return (
    String.fromCodePoint(base + (upper.charCodeAt(0) - 65)) +
    String.fromCodePoint(base + (upper.charCodeAt(1) - 65))
  );
}

export default function CountryFlag({ cc, showCode = true, sx }) {
  const emoji = codeToEmoji(cc);
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        fontFamily: tokens.fontMono,
        fontSize: 11,
        padding: "0 5px",
        border: `1px solid ${tokens.neutral[300]}`,
        borderRadius: 4,
        ...sx,
      }}
    >
      {emoji && (
        <span style={{ fontSize: 12, lineHeight: 1 }} aria-hidden>
          {emoji}
        </span>
      )}
      {showCode && (cc || "—")}
    </span>
  );
}
